module.exports = {
  props: ["options","value","desc","onSelectChange"],
  
  data: function () {
    return {
    	chosenOption: null,
    	showChoices: false,
    	lastValue: null,
    }
  },

  computed: {
  	displayText: function() { 		
  		if(this.value!=this.lastValue && typeof(this.onSelectChange)=='function') {
  			this.onSelectChange()
  		}
  		this.lastValue = this.value

  		for(var i in this.options) {
  			if(this.options[i].value==this.value) {
  				return this.options[i].text
  			}
  		}
			return this.desc
  	}
  },

  methods: {
  	onChoose: function($event,option) {
  		this.value = option.value
  		this.showChoices = false
  	}
  },

  // components: {	

  // },
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/controls/custom-select.vue
// module id = 148
// module chunks = 0